<template>
	<nta-dialog
		:show="props.show"
		height="auto"
		:title="
			symbolsStore.GUILabel('9347122d-d992-46c3-b774-6a54baa78d7f', {
				label: symbolsStore.GUILabel('12afad78-3062-4760-abac-e6637f270a1b'),
			})
		"
		:symbol-lang="domainStore.languagePreference"
		@close="() => cancel()"
	>
		<template #actions>
			<v-btn @click="() => cancel()">{{ symbolsStore.GUILabel("4c03e40c-9b2d-4090-9eca-46a4f6fd2a4e") }}</v-btn>
			<v-btn color="success" @click="() => add()">{{
				symbolsStore.GUILabel("9347122d-d992-46c3-b774-6a54baa78d7f", { label: "" })
			}}</v-btn>
		</template>
		<template #default>
			<v-card-text>
				<v-container>
					<v-autocomplete
						v-model="selectedUser"
						v-model:search="search"
						:items="searchItems"
						hide-details="auto"
						hide-no-data
						hide-selected
						:item-title="(u) => u.firstname + ' ' + u.lastname"
						item-value="id"
						:label="symbolsStore.GUILabel('b28185fc-108c-4c0a-bfad-fb6e4f624a68')"
						:placeholder="symbolsStore.GUILabel('c54a485e-4e57-426f-913f-11ce23f2b8d6')"
						prepend-icon="mdi-database-search"
						variant="outlined"
						return-object
						@update:search="searchUsers"
					></v-autocomplete>
				</v-container>
			</v-card-text>
		</template>
	</nta-dialog>
</template>

<script setup lang="ts">
import type { User, UserRole } from "@lr-notitia/notitia-operator/schemas";
import { ref, watch } from "vue";
import "@livereader/graphly-d3/style.css";
import { useDomainStore } from "../store/domain";
import { useSymbolsStore } from "../store/symbols";

const domainStore = useDomainStore();
const symbolsStore = useSymbolsStore();

const search = ref<string>("");
const selectedUser = ref<User | null>(null);
const searchItems = ref<User[]>([]);

const props = defineProps<{
	show: boolean;
	role: UserRole;
}>();
const emits = defineEmits(["cancel", "done", "add-member"]);

function cancel() {
	emits("cancel");
	emits("done");
}
function add() {
	if (!selectedUser.value) return;
	emits("add-member", selectedUser.value, props.role);
	emits("done");
}

function searchUsers() {
	if (search.value === "" || search.value === null) {
		searchItems.value = [];
		return;
	}
	domainStore
		.searchMember(search.value)
		.then((users) => {
			searchItems.value = [];
			for (let user of users) {
				if (domainStore.account.id === user.id) continue;
				if (searchItems.value.some((e) => e.id === user.id)) continue;
				searchItems.value.push(user);
			}
		})
		.catch((err) => {
			console.error(err);
		});
}

function reset() {
	selectedUser.value = null;
	searchItems.value = [];
}

watch(
	() => props.show,
	() => {
		if (!props.show) return;
		reset();
		searchUsers();
	}
);
</script>

<style scoped lang="scss"></style>
